export const BuildInfo = {timestamp:1771357909000}
